/*
 * @Author: zyq
 * @Date: 2022-10-21 16:30:24
 * @LastEditors: zyq
 * @LastEditTime: 2023-06-05 18:31:29
 * @description:
 */
export default {
  namespaced: true,

  // 数据节点
  state: () => ({
    userinfo: JSON.parse(localStorage.getItem('userinfo') || '{}'),
    userId: localStorage.getItem('userId') || '',
    tokenTime: localStorage.getItem('tokenTime') || '',
    isLogin: localStorage.getItem('isLogin') || '',
    token: localStorage.getItem('token') || '',
    pathName: '',
    userName: sessionStorage.getItem('userName') || ''
  }),

  // 方法节点
  mutations: {
    updateUseName (state, name) {
      state.userName = name
      this.commit('m_user/saveUserName')
    },
    saveUserName (state) {
      sessionStorage.setItem('userName', state.userName)
    },
    updatePathName (state, name) {
      state.pathName = name
    },
    updateUserInfo (state, userinfo) {
      state.userinfo = userinfo
      this.commit('m_user/saveUserInfoToStorage')
    },
    saveUserInfoToStorage (state) {
      localStorage.setItem('userinfo', JSON.stringify(state.userinfo))
    },
    updateUserId (state, userId) {
      state.userId = userId
      this.commit('m_user/saveUserIdToStoreage')
    },
    saveUserIdToStoreage (state) {
      localStorage.setItem('userId', state.userId)
    },
    updateLoginInfo (state, login) {
      state.isLogin = login
      this.commit('m_user/saveUserLogin')
    },
    saveUserLogin (state) {
      localStorage.setItem('isLogin', state.isLogin)
    },
    updateToken (state, token) {
      state.token = token
      this.commit('m_user/saveTokenToStorage')
    },
    saveTokenToStorage (state) {
      localStorage.setItem('token', state.token)
    },
    updateTokenTime (state, tokenTime) {
      state.tokenTime = tokenTime
      this.commit('m_user/saveTokenTimeToStorage')
    },
    saveTokenTimeToStorage (state) {
      localStorage.setItem('tokenTime', state.tokenTime)
    }

  },

  // 属性节点
  getters: {}

}
